import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { AuthService } from '../../../shared/service/auth-service/auth-service.service';

export class FieldDefinition {
  constructor(private injector: Injector) {}

  title: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'd-flex w-100',
      fieldGroup: [
        {
          className: 'flex-grow-1 me-3',
          key: 'filterTitle',
          type: 'input',
          props: {
            label: 'Request Title',
            placeholder: 'Enter title',
            tooltip: 'Name of your request',
            fieldDefinition: 'Name of your request',
            attributes: {
                title: 'Assign a name to identify your request',
            },
            maxLength: 50,
          },
        },
        {
          fieldGroupClassName: 'd-flex justify-content-center gap-4',
          fieldGroup: [
            {
              fieldGroupClassName: 'd-flex flex-column',
              fieldGroup: [
                {
                  key: 'xevmpd',
                  type: 'checkbox',
                  className: 'custom-formly-option-checkbox',
                  defaultValue: true,
                  props: { label: 'XML', attributes: {
                title: 'View the exported result in an XML file (codes only) ',
            }},
                  hooks: {
                    onInit: (field) => {
                      const excelControl = field.parent!.get!('excel').formControl;
                      const xevmpdDecodeControl = field.parent!.parent!.fieldGroup![1].get!('xevmpdDecoded').formControl;
                      const xevmpdDecodeControlField = field.parent!.parent!.fieldGroup![1].get!('xevmpdDecoded');
                      field.formControl?.valueChanges.subscribe((value) => {
                        if (!value || value == false) {
                          excelControl?.setValue(true);
                          xevmpdDecodeControl?.setValue(false);
                        }
                        xevmpdDecodeControlField.props!['disabled'] = (!value || value == false); 
                        xevmpdDecodeControlField.props!['readonly'] = xevmpdDecodeControlField.props!['disabled']; 
                      });
                      field.formControl?.setValue(field.formControl.value); // set initial state
                    },
                  },
                }, 
                {
                  key: 'excel',
                  type: 'checkbox',
                  className: 'custom-formly-option-checkbox',
                  defaultValue: false,
                  props: { label: 'Excel', attributes: {
                title: 'View the exported result in an excel file (codes only)',
            } },
                  hooks: {
                    onInit: (field) => {
                      const xEVMPDControl = field.parent!.get!('xevmpd').formControl;
                      const excelDecodeControl = field.parent!.parent!.fieldGroup![1].get!('excelDecoded').formControl;
                      const excelDecodeControlField = field.parent!.parent!.fieldGroup![1].get!('excelDecoded');
                      field.formControl?.valueChanges.subscribe((value) => {
                        if (!value || value == false) {
                          xEVMPDControl?.setValue(true);
                          excelDecodeControl?.setValue(false);
                        }
                        excelDecodeControlField.props!['disabled'] = (!value || value == false); 
                        excelDecodeControlField.props!['readonly'] = excelDecodeControlField.props!['disabled']; 
                      });
                      field.formControl?.setValue(field.formControl.value); // set initial state
                    },
                  },
                }, 
              ],
            },
            {
              fieldGroupClassName: 'd-flex flex-column',
              fieldGroup: [
                {
                  key: 'xevmpdDecoded',
                  type: 'checkbox',
                  className: 'custom-formly-option-checkbox',
                  defaultValue: false,
                  props: { label: '(Decoded)', attributes: {
                title: 'View the exported result in an XML file (codes and codes descriptions)',
            }  },
                },
                {
                  key: 'excelDecoded',
                  type: 'checkbox',
                  className: 'custom-formly-option-checkbox',
                  defaultValue: false,
                  props: { label: '(Decoded)',  attributes: {
                title: 'View the exported result in an excel file (codes and codes descriptions)',
            }   },
                },
              ],
            },
          ],
        },
        {
          key: 'filterCount',
        },
      ],
    },
    {
      key: 'bulkUpdate',
      defaultValue: false
    }
  ];

  filters: FormlyFieldConfig[] = [
    {
      key: 'versionToExport',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          props: {
            disabled: true,
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: 6,
          type: 'bulkRadioType',
          props: {
            label: 'Version to Export',
            lookupname: 'versiontoexport',
            valueProp: 'code',
            labelProp: 'name',
            showClear: false,
            fieldDescription:
              'Select which product version should be exported (last version or last version assessed as valid)',
            hidden: false,
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'assessment',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkRadioType',
          props: {
            label: 'Version Assessment',
            lookupname: 'pendingValues',
            valueProp: 'code',
            labelProp: 'name',
            fieldDescription: 'Select what should be the assessment status of the product entity as present in the product pending field within the AMP',
            showClear: true,
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr  />' },
    {
      key: 'art57Format',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkRadioType',
          props: {
            label: 'Article 57 Format',
            lookupname: 'bulkart57Format',
            valueProp: 'code',
            labelProp: 'name',
            fieldDescription: 'Select in which format the product entity was submitted',
            showClear: true,
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr  />' },
    {
      key: 'interimFormat',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkRadioType',
          props: {
            label: 'Interim Format',
            lookupname: 'bulkinterimFormat',
            valueProp: 'code',
            labelProp: 'name',
            fieldDescription: 'Select in which format the product entity was submitted',
            showClear: true,
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'startDate',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkDateType',
          props: {
            label: 'Last Update (From)',
            fieldDescription: 'Select the start date when the product was last updated',
            showClear: true,
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'endDate',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkDateType',
          props: {
            label: 'Last Update (To)',
            fieldDescription: 'Select the end date when the product was last updated',
            showClear: true,
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'authorisedDevelopment',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          defaultValue: null,
          type: 'bulkRadioType',
          props: {
            label: 'Authorised / Development',
            lookupname: 'bulkProductTypes',
            valueProp: 'code',
            labelProp: 'name',
            showClear: true,
            fieldDescription:
              'Select product type: authorised or development product',
            hidden: true,
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'drugingredients',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Ingredient',
            fieldDescription:
              'Enter or select substance(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'bulkdrugingredient',
                  placeholder: 'Select items',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'pharmaceuticalforms',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Pharmaceutical Form',
            fieldDescription:
              'Enter or select pharmaceutical form(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'bulkpharmaceuticalform',
                  placeholder: 'Select items',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'atccodes',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'ATC Code',
            fieldDescription:
              'Enter or select ATC Code(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'bulkatccode',
                  placeholder: 'Select items',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'indicationmeddracodes',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Indication MedDRA Code',
            fieldDescription:
              'Enter or select MedDRA Code(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'indicationmeddracode',
                  placeholder: 'MedDRA Codes',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'organisations',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'MAH / Sponsor',
            fieldDescription:
              'Enter or select organisation(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'bulkorganisation',
                  placeholder: 'MAH / Sponsor',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },

    {
      key: 'qppvs',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
          hideExpression: (field) => {
            return (
              this.injector.get(AuthService).isDatamaskedUser()
            );
          },        
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'QPPV',
            fieldDescription: 'Select QPPV(s) referenced in the last version of AMPs owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'bulkqppv',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: true,
            showSearchField:
              this.injector.get(AuthService).isEMAorNCAOrganisation()
          },
          hideExpression: (field) => {
            return (
              this.injector.get(AuthService).isDatamaskedUser() ||
              field?.props?.hidden
            );
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    {
      type: 'template',
      template: '<hr />',
      hideExpression: (field) => {
        return (
          this.injector.get(AuthService).isDatamaskedUser() ||
          field.props?.hidden
        );
      },
    },
    {
      key: 'mfls',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Master File Location',
            fieldDescription: 'Select MFL(s) referenced in the last version of AMPs owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'bulkmfl',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: true,
            showSearchField:
              this.injector.get(AuthService).isEMAorNCAOrganisation(),
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'ownerorganisations',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Sender Organisation',
            fieldDescription: 'Select the organisation(s) that submitted the last version of products owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'owneridsproduct',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: true,
            showSearchField: false,
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'authorisationcountrycodes',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Authorisation Country Code',
            fieldDescription: 'Select authorisation country code(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'authorisationcountrycode',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: true,
            showSearchField: false,
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'authorisationprocedures',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Authorisation Procedure',
            fieldDescription: 'Select authorisation procedure(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'bulkauthorisationprocedure',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: false,
            showSearchField: false,
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'authorisationstatuses',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Authorisation Status',
            fieldDescription: 'Select authorisation status(es) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
            lookupname: 'bulkauthorisationstatus',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 5,
            showCode: false,
            showSearchField: false,
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'anynames',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Product Any Name',
            fieldDescription:
              'Enter or select any product name(s) referenced in the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'anyname',
                  placeholder: 'Any Name',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: false,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'fullnames',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Full Presentation Name',
            fieldDescription:
              'Enter or select any product name(s) referenced in the ' + "'" + 'Full Presentation Name' + "'" + ' field of the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'fullname',
                  placeholder: 'Full Name',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: false,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'shortnames',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Product Short Name',
            fieldDescription:
              'Enter or select any product name(s) referenced in the ' + "'" + 'Product Short Name' + "'" + ' field of the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'shortname',
                  placeholder: 'Short Name',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: false,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'genericnames',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Product INN/Common Name',
            fieldDescription:
              'Enter or select any product name(s) referenced in the ' + "'" + 'Product INN/Common Name' + "'" + ' field of the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'genericname',
                  placeholder: 'Generic Name',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: false,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'companynames',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'Product Company Name',
            fieldDescription:
              'Enter or select any MAH name(s) referenced in the ' + "'" + 'Product Company Name' + "'" + ' field of the last version of products owned by your HQ organisation. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'companyname',
                  placeholder: 'Company Name',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: false,
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'evcodes',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'repeat',
          props: {
            hidden: true,
            label: 'EV Code',
            fieldDescription:
              'Enter or select ev code. Multiple selection allowed',
          },
          fieldArray: {
            fieldGroup: [
              {
                key: 'selected',
                type: 'bulkLookupSelectorType',
                props: {
                  lookupname: 'evcode',
                  placeholder: 'EV Code',
                  searchPlaceholder: 'Look for entities and press Enter',
                  valueProp: 'code',
                  labelProp: 'name',
                  size: 5,
                  multiple: true,
                  showCode: true,
                  allowCount: true
                },
              },
              {
                key: 'datasource',
              },
              {
                key: 'operator',
                defaultValue: 'cn',
              },
              {
                key: 'term',
              },
              {
                key: 'lastOrder',
              },
              {
                key: 'componentID',
                defaultValue: 'pending_init',
              },
            ],
          },
        },
      ],
    },
    { type: 'template', template: '<hr />' },
    {
      key: 'previews',
      fieldGroupClassName: 'd-flex align-items-start',
      fieldGroup: [
        {
          className: 'custom-formly-checkbox flex-shrink-0 mt-2',
          key: 'filterStatus',
          type: 'checkbox',
          defaultValue: false,
          props: {
             attributes: {
                title: 'Select / Deselect filter',
            }
          },
        },
        {
          key: 'hasSelectedData',
          defaultValue: false,
        },
        {
          className: 'flex-grow-1',
          key: 'filterData',
          type: 'bulkLookupListType',
          props: {
            label: 'Preview List',
            fieldDescription:
              'Displays the list (maximum 1000 ev codes) of products retrieved as per specified filters. Multiple selection allowed',
            functionname: 'previewfnc',
            valueProp: 'code',
            labelProp: 'name',
            hidden: true,
            size: 15,
            showCode: true,
            showSearchField: false,
          },
        },
        {
          key: 'datasource',
        },
        {
          key: 'operator',
          defaultValue: 'cn',
        },
        {
          key: 'term',
        },
        {
          key: 'lastOrder',
        },
      ],
    },
    { type: 'template', template: '<hr />' },
  ];

  monitor: FormlyFieldConfig[] = [
    {
      key: 'requestExecuting',
      defaultValue: 0,
      type: 'input',
      hide: true,
    },
  ];

  downloads: FormlyFieldConfig[] = [{}];

  
}
